import {CopilotImageAttacher} from '@github-ui/copilot-chat/utils/copilot-image-attacher'
import {CopilotTextAttacher} from '@github-ui/copilot-chat/utils/copilot-text-attacher'
import type {CopilotChatModel} from '@github-ui/copilot-chat-types'

export class UploadableFileExtensions {
  static #textFileExtensionsCache: Set<string> | undefined
  static get text(): Set<string> {
    if (this.#textFileExtensionsCache != null) return this.#textFileExtensionsCache

    const extensions = [
      ...CopilotTextAttacher.getTextFileExtensions().split(','),
      ...['.babelrc', '.conf', '.eslintrc', '.lock', '.log', '.npmrc', '.prettierrc', '.sum', '.yarnrc'],
    ]
    this.#textFileExtensionsCache = new Set(extensions.map(ext => ext.toLowerCase()))
    return this.#textFileExtensionsCache
  }

  static images(models: CopilotChatModel[]): Set<string> {
    const extensions = CopilotImageAttacher.getFileExtensions(models)
    return new Set(extensions.map(ext => ext.toLowerCase()))
  }
}
